import appConfig from "../app-config";

/**
 * Generates a url for an avatar. The avatar can be explicity defined using the
 * `colorIndex` argument to set a color
 * @param {string} userID - id of the avatar
 * @param {number} colorIndex - color index to use
 */
const avatarURL = (userID, colorIndex = null) => {
	const prefix = "avatar";

	if (colorIndex !== null) {
		return `${appConfig.mediaCDN}${prefix}/gen/${colorIndex}/${userID}/`;
	}

	return `${appConfig.mediaCDN}${prefix}/${userID}/`;
};

export default avatarURL;
